import { Field } from './Field';
import { IRangeField } from './IRangeField';
import { ComparisonType } from './ComparisonType';

export class NumberRangeField extends Field implements IRangeField<number> {
  public begin: number;
  public end: number;
  public factor: number;

  constructor(name: string, description: string, factor: number, begin: number = null, end: number = null, comparisonType: ComparisonType = null) {
    super(name, description, NumberRangeField.typeName(), comparisonType);

    this.factor = factor;
    this.begin = begin;
    this.end = end;
  }

  public static typeName(): string {
    return "io.indexed.domainmodel.search.advanced.NumberRangeField";
  }
}
